import { IAppState } from 'models/store.model'
import { paymentReducer } from 'modules/purchase/redux/reducer'
import { combineReducers } from 'redux'
import { commonReducer } from 'root-redux/reducers/common'
import { userReducer } from 'root-redux/reducers/user'

export const rootReducer = combineReducers<IAppState>({
  common: commonReducer,
  user: userReducer,
  payment: paymentReducer,
})
